<template>
  <section class="menus-detail-container">
    <base-header
      v-bind="headers"
    />
    <base-form
      ref="form"
      v-bind="form"
      v-on:handleConfirm="handleConfirm"
    >
      <template #content="scope">
        <div class="apis-list-wrap">
          <u-editor
            v-model="scope.form[scope.item.prop]"
          ></u-editor>
        </div>
      </template>
    </base-form>
  </section>
</template>
<script>
import baseHeader from '@/components/mixins/baseHeader'
import baseForm from '@/components/mixins/baseForm'
import formDialog from '@/components/mixins/formDialog'
import msgDialog from '@/components/mixins/msgDialog'
import UEditor from '@/components/editor/UEditor'

export default {
  name: 'extcontentCheck',
  mixins: [baseHeader, baseForm, msgDialog, formDialog],
  components: {
    UEditor
  },
  data () {
    return {
      form: {
        api: 'fetchOabuinessRecordDetail',
        params: {
          id: ''
        },
        form: {
          id: '',
          title: '',
          content: ''
        },
        formItems: [
          {
            prop: 'title',
            label: '记录名称：',
            maxlength: 50,
            placeholder: '不超过50字'
          },
          {
            prop: 'content',
            label: '记录内容：',
            type: 'slot'
          }
        ],
        rules: {
          title: [
            this.$rules.required()
          ],
          content: [
            this.$rules.required()
          ]
        },
        submitBtns: [
          {
            text: '保存',
            subType: 'submit',
            notDisabled: true
          }
        ]
      },
      headers: {
        buttons: [],
        title: '新增记录',
        showAlertIcon: false,
        content: ''
      }
    }
  },
  inject: ['removeTab'],
  methods: {
    // 保存提交
    handleConfirm (data) {
      this.form.loading = true
      this.$request.fetchOabuinessRecordUpdate(data).then(res => {
        this.hideFormLoading()
        if (res.code === 200) {
          this.$refs.form.resetFields()
          this.removeTab(this.$route.fullPath)
          this.$router.replace({ name: 'oabusinessRecordIndex' })
        }
      }).catch(this.hideFormLoading)
    },
    fetchFormCallBack (res) {
      if (res.code === 200) {
        this.form.form = res.data
      }
    }
  },
  mounted () {
    const { id } = this.$route.query
    this.form.params.id = id
    this.fetchFormApi()
  },
  activated () {
    const { id } = this.$route.query
    if (id) {
      this.form.params.id = id
      this.fetchFormApi()
    }
  }
}
</script>
<style lang="scss" scoped>
.menus-detail-container{
  .apis-list{
    color: #666666;
    display: flex;
    flex-direction: column;
    width: 414px;
    .api-item{
      font-size: 14px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      line-height: 22px;
      padding: 10px 30px 10px 10px;
      border: 1px solid #e8e8e8;
      border-radius: 4px;
      margin-top: 10px;
      position: relative;
      span {
        word-break: break-all;
      }
      span:last-of-type{
        flex: 1;
      }
      i{
        cursor: pointer;
        position: absolute;
        right: 10px;
      }
    }
  }
  .status-list {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    border: solid 1px #e5e5e5;
    .status-item {
      display: flex;
      align-items: center;
      padding: 20px;
      box-sizing: border-box;
      span {
        display: block;
        text-align: left;
      }
      .text {
        line-height: 26px;
        color:#5f5d5d;
      }
      .title {
        color: #000;
      }
    }
    .status-icon {
      margin-left: 20px;
    }
  }
  .tip-header {
    height: 40px;
    background:#f2fbfc;
    border:1px solid #1fc6df;
    border-radius:4px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    margin-right: 40px;
    margin-bottom: 40px;
    box-sizing: border-box;
    .title {
      font-size:14px;
      color:#000000;
    }
    .button {

    }
  }
}
</style>
